import React from 'react';

const GenericIcon: React.FC<{className?: string}> = ({ className = "w-12 h-8" }) => (
  <svg className={className} viewBox="0 0 48 32" fill="none">
    <rect width="48" height="32" rx="4" fill="#E0E0E0"/>
    <rect x="8" y="10" width="32" height="4" rx="2" fill="#BDBDBD"/>
    <rect x="8" y="18" width="24" height="2" rx="1" fill="#BDBDBD"/>
    <rect x="8" y="22" width="16" height="2" rx="1" fill="#BDBDBD"/>
  </svg>
);

export default GenericIcon; 